export class EuiPickerItem {
    id: number;
    label: string;
    isSelected = false;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
